<button
  type="button"
  aria-label="Delete"
  (click)="onDelete()"
  class="flex cursor-pointer"
>
  <nsp-icon [name]="IconNames.TrashAlt" />
</button>
